<template>
  <div class="subscription-wrapper">
    <!-- Hero Section -->
    <section class="hero-section py-6 mb-6">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8" lg="6" class="text-center">
            <h1 class="text-h3 mb-4" style="color: #2ab3b8; font-weight: 500">
              Subscribe to Dynamic Insights
            </h1>
            <p class="text-h6 mx-auto" style="color: #37474f; line-height: 1.6">
              Unlock powerful analytics and insights to drive your business
              forward. Choose the plan that's right for you.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Subscription Plans -->
    <section class="subscription-section">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="10" lg="8">
            <SubscriptionPlans
              app-code="di"
              :plans="plans"
              :current-level="currentPlan"
              :manage-subscription-path="tenantSettingsPath"
              default-currency="nzd"
              require-terms
            />
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import { SubscriptionPlans } from "@devcentre/tenancy-components/src/index.js";

export default {
  name: "SubscriptionPaymentView",

  components: { SubscriptionPlans },

  data: () => ({
    plans: [
      {
        level: "basic",
        title: "Basic Dynamic Insights",
        subtitle: "Ideal for trying out the service or non profits",
        free: true,
        features: [
          "One Free project",
          "Up to 30 participants",
          "AI Data Analysis",
        ],
      },
      {
        level: "professional",
        title: "Professional Dynamic Insights",
        subtitle: "Perfect for professional market researchers",
        recommended: true,
        features: [
          "Up to 5 live projects",
          "Up to 500 participants per project",
          "AI Data Analysis",
          "Advanced Visualizations",
          "Export data in Excel format",
        ],
      },
    ],
  }),

  computed: {
    currentPlan() {
      return this.$store.getters.currentPlan;
    },

    tenantSettingsPath() {
      const tenantId = this.$store.getters.currentTenant?.tenant_id;
      return tenantId ? `/tenants/${tenantId}/settings` : "/tenants";
    },
  },
};
</script>

<style scoped>
.subscription-wrapper {
  background: linear-gradient(to bottom, #ffffff, #f5f5f5);
  min-height: 100vh;
}

.hero-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}
</style>
